const ns = "ORDERS_ORDERS_BY_RECORD";
export const RECEIVE = `${ns}_RECEIVE`;
export const REQUEST = `${ns}_REQUEST`;
export const INVALIDATE = `${ns}_INVALIDATE`;
